<template>
  <div class="navbar-profile">
    <router-link :to="{ name: 'Notifications' }" class="notifications">
      <img src="@/assets/icons/nav/Notifications.svg" alt="Notifications" />
      <div class="dot-new" v-if="unreadNotifications.length">{{ unreadNotifications.length }}</div>
    </router-link>
    <router-link :to="{ name: 'Profile' }" class="user">
      <Avatar size="m" :src="user.avatar" />
      <div v-if="user" class="user-name">{{ $localized(user.localized_name, user.first_name) }} {{ $localized(user.localized_surname, user.last_name) }}</div>
    </router-link>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Avatar from '@/components/user/Avatar'

export default {
  name: 'NavbarProfile',
  components: { Avatar },
  computed: {
    user() {
      return this.$auth.user() ?? {}
    },
    unreadNotifications() {
      return this.notifications.filter((x) => x.read_at === null)
    },
    ...mapGetters('events', ['notificationNew']),
    ...mapState('notifications', ['notifications']),
  },
}
</script>

<style lang="scss">
.navbar-profile {
  display: flex;
  align-items: center;

  .notifications {
    position: relative;
    display: inline-block;
    margin-right: 32px;

    &.router-link-active::after {
      content: '';
      position: absolute;
      top: -29px;
      left: 50%;
      width: 30px;
      transform: translateX(-50%);
      height: 4px;
      background: $primary;
    }

    .dot-new {
      position: absolute;
      top: -5px;
      right: -5px;
      width: 11px;
      height: 11px;
      box-sizing: content-box;
      border-radius: 50%;

      color: white;
      font-size: 8px;
      line-height: 11px;

      background: $primary;
      border: 2px solid #f7f7f7;
      text-align: center;
    }
  }

  .user {
    display: flex;
    align-items: center;

    .user-name {
      font-weight: 400;
      font-size: 15px;
      line-height: 157.5%;
      color: $text;

      margin-left: 12px;
    }
  }
}
</style>
